/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetUnreadCountRequest} from '@cash-web/protos/squareup/cash/supportal/app.pb'
import {GetUnreadCountResponse} from '@cash-web/protos/squareup/cash/supportal/app.pb'


export const getUnreadCount = (request:GetUnreadCountRequest, options?: CashRequestOptions) => post<GetUnreadCountRequest, GetUnreadCountResponse>("/2.0/cash/get-unread-count", request, {...options, rejectOnError: true })